require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vice-prsidence-innovation-0-3-2.json") })
        }
      }, "path---vice-prsidence-innovation-0-3-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---vice-prsidence-innovation-0-3-2!./.cache/json/vice-prsidence-innovation-0-3-2.json
// module id = 603
// module chunks = 231608221292675